import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import AuthPage from './pages/AuthPage';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminLogin from './pages/AdminLogin';
import PublicPoll from './pages/PublicPoll';
import RedeemDeal from './pages/RedeemDeal';
import MenuEditorPage from './pages/MenuEditorPage';
import InstallPrompt from './components/InstallPrompt';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Unregister old service workers to bust iOS cache
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      });
    }

    // Check for existing token
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    const userData = localStorage.getItem('user');

    if (token && role) {
      if (role === 'admin') {
        setAdmin({ token, username: 'admin' });
      } else {
        setUser(JSON.parse(userData));
      }
    }
    setLoading(false);
  }, []);

  const handleLogin = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('role', data.role);
    if (data.role === 'user') {
      localStorage.setItem('user', JSON.stringify(data.user));
      setUser(data.user);
    } else {
      setAdmin({ token: data.token, username: data.username });
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('user');
    setUser(null);
    setAdmin(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="animate-pulse text-[#EAB308] text-xl font-heading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <Toaster
        position="top-center"
        theme="dark"
        richColors
        offset="calc(env(safe-area-inset-top) + 64px)"
        toastOptions={{ style: { borderRadius: '9999px', padding: '12px 18px', width: 'fit-content', maxWidth: '92vw', margin: '0 auto' } }}
      />
      <InstallPrompt />
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              user ? (
                <UserDashboard user={user} onLogout={handleLogout} />
              ) : admin ? (
                <Navigate to="/admin" replace />
              ) : (
                <AuthPage onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/join"
            element={
              user ? (
                <Navigate to="/" replace />
              ) : admin ? (
                <Navigate to="/admin" replace />
              ) : (
                <AuthPage onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/admin-login"
            element={
              admin ? (
                <Navigate to="/admin" replace />
              ) : (
                <AdminLogin onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/admin"
            element={
              admin ? (
                <AdminDashboard admin={admin} onLogout={handleLogout} />
              ) : (
                <Navigate to="/admin-login" replace />
              )
            }
          />
          <Route path="/admin/menus/:menuId" element={admin ? <MenuEditorPage /> : <Navigate to="/admin-login" replace />} />
          <Route path="/poll/:pollId" element={<PublicPoll />} />
          <Route path="/redeem/:code" element={<RedeemDeal />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
